
// Selectors
export const selectUsetOrganizationList = (state) =>
  state.orgData.userOrgList

